// Use named import for StrictMode only. With the new React 17+ JSX runtime
// (`jsx`: "react-jsx" in tsconfig), React itself is no longer implicitly
// imported for JSX transformation. We avoid relying on the default React
// export at runtime, which can be undefined in some bundling scenarios.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

// Grab the root element from the HTML
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  // Render the main application. Using <StrictMode> here ensures that
  // development mode warnings and checks are enabled without relying on
  // a default React export.

  root.render(
    <StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </StrictMode>
  );
}
